import { useSuspenseQuery } from '@tanstack/react-query';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { fetchESimProfiles } from '../api/eSimProfilesApi';
import { eSimProductsQueries } from 'src/products/esim/utils/esimProductsQueries';

export const useESimProfiles = ({ eid }: { eid: string }) => {
  const queryResult = useSuspenseQuery({
    queryKey: eSimProductsQueries.profilesList({ eid }),
    queryFn: async ({ signal }) => {
      const result = await setMinimalPromiseTime(fetchESimProfiles({ eid }, signal));

      return result;
    },
  });

  return { queryResult };
};
